import React from 'react';
import Box from 'components/react-styled-core/Box';

const FontStyle = ({ children }) => (
    <Box
        fontFamily="base"
        fontSize="md"
        lineHeight="base"
        color="gray:140"
        bg="gray:30"
        height="100%"
        pb="8x"
    >
        {children}
    </Box>
);

export default FontStyle;
